import React from "react";
import Image from "next/image";
import { gql } from "@apollo/client";
import { Typography } from "ui-kit";
import { ContentfulComponentType } from "../types";
import { PromoBanner } from "../../../../__generated__/graphql";
import styles from "./ContentfulPromoBanner.module.css";

export const ContentfulPromoBanner: ContentfulComponentType<PromoBanner> = ({
  showHeader,
  headerTitle,
  headerSubline,
  image,
  personName,
  personRole,
  quote,
  signature,
}) => {
  const hasHeader = showHeader && (headerTitle || headerSubline);

  return (
    <div className="container">
      <section className={styles.section}>
        {hasHeader && (
          <div className={styles.header}>
            {headerTitle && (
              <Typography variant="headingLg">{headerTitle}</Typography>
            )}
            {headerSubline && (
              <Typography variant="bodyLg" className={styles.subline}>
                {headerSubline}
              </Typography>
            )}
          </div>
        )}

        <div className={styles.card}>
          {image?.url && (
            <div className={styles.imageBlock}>
              <Image
                src={image.url}
                alt={image.description ?? personName ?? ""}
                fill
                sizes="(max-width: 1200px) 100vw, 50vw"
                className={styles.image}
              />
            </div>
          )}

          <div className={styles.textBlock}>
            {(personName || personRole) && (
              <div className={styles.person}>
                {personName && (
                  <Typography variant="headingXs" className={styles.name}>
                    {personName}
                  </Typography>
                )}
                {personRole && (
                  <Typography
                    variant="captionSmRegular"
                    className={styles.role}
                  >
                    {personRole}
                  </Typography>
                )}
              </div>
            )}

            {quote && (
              <Typography variant="headingMd" className={styles.quote}>
                {quote}
              </Typography>
            )}

            {signature?.url && (
              <div className={styles.signature}>
                <Image
                  src={signature.url}
                  alt={personName ? `${personName} signature` : ""}
                  fill
                  sizes="215px"
                  className={styles.signatureImage}
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

ContentfulPromoBanner.fragment = gql`
  fragment PromoBanner on ComponentPromoBanner {
    showHeader
    headerTitle
    headerSubline
    personName
    personRole
    quote
    image {
      sys {
        id
      }
      url
      description
      width
      height
      contentType
    }
    signature {
      sys {
        id
      }
      url
      description
      width
      height
      contentType
    }
    sys {
      id
      publishedAt
    }
  }
`;
